import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { authGuard } from "./core/guards/auth.guard";
import { LayoutComponent } from "./layouts/layout.component";
import { Page404Component } from "./extrapages/page404/page404.component";

const routes: Routes = [
  {
    path: "account",
    loadChildren: () =>
      import("./account/account.module").then((m) => m.AccountModule),
  },

  // ✅ INTRANET (admin/staff)
  {
    path: "",
    component: LayoutComponent,
    loadChildren: () =>
      import("./pages/pages.module").then((m) => m.PagesModule),
    canActivate: [authGuard],
  },

  // ✅ CLIENTE (con el MISMO layout)
  {
    path: "c",
    component: LayoutComponent,
    loadChildren: () =>
      import("../app/pages/cliente/cliente.module").then((m) => m.ClienteModule),
    canActivate: [authGuard],
  },

  {
    path: "pages",
    loadChildren: () =>
      import("./extrapages/extrapages.module").then((m) => m.ExtrapagesModule),
    canActivate: [authGuard],
  },

  { path: "**", component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
